export function setJsonLd(id: string, data: object | null) {
  const existing = document.getElementById(id) as HTMLScriptElement | null;
  if (data === null) {
    existing?.remove();
    return;
  }
  const script = existing || document.createElement('script');
  script.id = id;
  script.type = 'application/ld+json';
  script.textContent = JSON.stringify(data);
  if (!existing) document.head.appendChild(script);
}